import { render, staticRenderFns } from "./crudReport.vue?vue&type=template&id=2c1b683d&scoped=true&"
import script from "./crudReport.vue?vue&type=script&lang=js&"
export * from "./crudReport.vue?vue&type=script&lang=js&"
import style0 from "./crudReport.vue?vue&type=style&index=0&id=2c1b683d&prod&lang=css&"
import style1 from "./crudReport.vue?vue&type=style&index=1&id=2c1b683d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b683d",
  null
  
)

export default component.exports